var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-item"},[_c('div',{staticClass:"title_name",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_vm._v("仓库信息")])])])
}]

export { render, staticRenderFns }